/**
 * Banner displayed to Admin Profile users on the settings page
 * to inform them they have limited access based on their profile.
 */

import { InlineAlertType, InlineAlertWidget } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { Messages } from '../../codegen/Localize';

const bannerStyle = style({
  marginBottom: 16,
});

/**
 * Shows an informational banner explaining the user has limited access to
 * settings based on their Admin Profile.
 *
 * The caller is responsible for deciding whether to render this banner —
 * this component does not self-gate on session role.
 */
export const LimitedAccessBanner: React.FC = () => {
  return (
    <InlineAlertWidget
      type={InlineAlertType.Info}
      className={bannerStyle}
      testId="limited-settings-access-banner"
    >
      {Messages.limitedSettingsAccessBanner()}
    </InlineAlertWidget>
  );
};

LimitedAccessBanner.displayName = 'LimitedAccessBanner';
